/** @format */
import { ChangeDetectionStrategy, Component, inject, input, OnInit, output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FudisSelectOption } from '@funidata/ngx-fudis';
import { Module, TimingTemplate } from 'common-typescript/types';
import { map, Observable, take } from 'rxjs';
import { LocaleService } from 'sis-common';
import { AppErrorHandler } from 'sis-components';
import { ActiveTimingTemplateService } from '../active-timing-template.service';

@Component({
    selector: 'app-module-timing-template',
    standalone: false,
    templateUrl: './module-timing-template.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModuleTimingTemplateComponent implements OnInit {
    private readonly activeTimingTemplateService = inject(ActiveTimingTemplateService);
    private readonly localeService = inject(LocaleService);
    private readonly appErrorHandler = inject(AppErrorHandler);

    readonly module = input.required<Module>();
    readonly selectedTemplate = output<TimingTemplate | null>();

    protected timingTemplateOptions$: Observable<FudisSelectOption<TimingTemplate>[]>;
    protected readonly templateSelectControl = new FormControl<null | FudisSelectOption<TimingTemplate>>(null);

    ngOnInit() {
        this.timingTemplateOptions$ = this.activeTimingTemplateService.getActiveTimingTemplates(this.module().id).pipe(
            take(1),
            map(templates =>
                templates.map(
                    template =>
                        <FudisSelectOption<TimingTemplate>>{
                            value: template,
                            label: `${this.localeService.localize(template.name)} ${template.studyYear}`,
                        },
                ),
            ),
            this.appErrorHandler.defaultErrorHandler(),
        );
    }

    protected emitSelectedTemplate(templateOption: null | FudisSelectOption<TimingTemplate>): void {
        this.selectedTemplate.emit(templateOption?.value ?? null);
    }
}
